export const tokens = {
    zindex: {
        wrapper: 1,
        interior: 2,
        conicTimer: 3,
        content: 4,
    },
    glow: 16,
    radius: 999,
    wrapper: {
        borderWidth: 2,
    },
    focusRing: {
        offset: 4,
    },
    padding: {
        default: 26,
        compact: 16,
    },
    height: {
        default: 40,
        compact: 32,
    },
    fontSize: {
        default: 14,
        compact: 12,
    },
    conicTimer: {
        duration: 4000,
    },
};
